<div class="mr-4 inline-flex items-center">
  @if (entry.is_liked_by_user) {
    <ng-icon name="heroHeartSolid" class="text-red-500" size="1.25rem" (click)="toggleLike()"/>
  } @else if (!entry.is_liked_by_user) {
    <ng-icon name="heroHeart" class="" size="1.25rem" (click)="toggleLike()"/>
  }

  @if (entry.likes > 0) {
    <span class="text-sm pl-1">{{ entry.likes }}</span>
  }
</div>

@if (shareService.canShare()) {
  <ng-icon name="heroShare" class="mr-4" size="1.25rem" (click)="share()"/>
}
@if (authService.currentUser()) {
  <ng-icon name="heroAdjustmentsHorizontal" size="1.25rem" (click)="openPreferences()"/>
}
